
import VMainTitle from "../VMainTitle"
import styles from "./VMainBenefits.module.css"

// Icons
import icon_1 from "../../../assets/img/by_page/main/benefits/cog.svg"
import icon_2 from "../../../assets/img/by_page/main/benefits/health.svg"
import icon_3 from "../../../assets/img/by_page/main/benefits/trophy.svg"

const VMainBenefits = () => {
  return (
    <section className={styles.our_benefits}>
        <VMainTitle title='Наши преимущества' subtitle='Наши преимущества - Ваш успех!'/>
        <div className={styles.wrapper}>
            
            <div className={"card__wrapper " + styles.wrapper_around}>
                <div className={"card__content " + styles.card__content}>
                    <div className={styles.benefit_icon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {/* Трофей */}
                          <path d="M14 8C14 8 12 8 12 10C12 12 12 16 16 18C18 19 20 19 22 19" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M34 8C34 8 36 8 36 10C36 12 36 16 32 18C30 19 28 19 26 19" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 8H32V18C32 22.4183 28.4183 26 24 26C19.5817 26 16 22.4183 16 18V8Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M24 26V34M20 34H28M18 38H30" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="24" cy="14" r="1.5" fill="white"/>
                        </svg>
                    </div>
                    <h3 className={styles.benefit_title}>Опыт с 1997 года</h3>
                    <p className={styles.benefit_desc}>Первый производитель экологически чистой озонированной питьевой воды в Казахстане</p>
                </div>
            </div>

            <div className={"card__wrapper " + styles.wrapper_around}>
                <div className={"card__content " + styles.card__content}>
                    <div className={styles.benefit_icon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {/* Слои фильтрации - стек пластин */}
                          <rect x="10" y="8" width="28" height="6" rx="2" stroke="white" strokeWidth="2.5" fill="white" opacity="0.1"/>
                          <rect x="10" y="16" width="28" height="6" rx="2" stroke="white" strokeWidth="2.5" fill="white" opacity="0.15"/>
                          <rect x="10" y="24" width="28" height="6" rx="2" stroke="white" strokeWidth="2.5" fill="white" opacity="0.2"/>
                          <rect x="10" y="32" width="28" height="6" rx="2" stroke="white" strokeWidth="2.5" fill="white" opacity="0.25"/>
                          
                          {/* Стрелки прохождения воды сверху вниз */}
                          <path d="M6 6V40M6 40L4 38M6 40L8 38" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
                          <path d="M42 6V40M42 40L40 38M42 40L44 38" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
                          
                          {/* Точки/частицы на входе */}
                          <circle cx="18" cy="4" r="1" fill="white" opacity="0.7"/>
                          <circle cx="24" cy="3" r="1.2" fill="white" opacity="0.6"/>
                          <circle cx="30" cy="4" r="0.8" fill="white" opacity="0.7"/>
                          
                          {/* Чистые капли на выходе */}
                          <circle cx="20" cy="42" r="1.5" fill="white" opacity="0.9"/>
                          <circle cx="28" cy="42" r="1.5" fill="white" opacity="0.9"/>
                          <circle cx="24" cy="44" r="1.2" fill="white" opacity="0.85"/>
                        </svg>
                    </div>
                    <h3 className={styles.benefit_title}>Многоступенчатая очистка</h3>
                    <p className={styles.benefit_desc}>Цеолит, полипропилен, обратный осмос и озонирование с высокотехнологичным оборудованием</p>
                </div>
            </div>

            <div className={"card__wrapper " + styles.wrapper_around}>
                <div className={"card__content " + styles.card__content}>
                    <div className={styles.benefit_icon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {/* Большая капля - центральный элемент */}
                          <path d="M24 6C24 6 12 18 12 28C12 35.732 17.373 42 24 42C30.627 42 36 35.732 36 28C36 18 24 6 24 6Z" 
                                stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M24 6C24 6 12 18 12 28C12 35.732 17.373 42 24 42C30.627 42 36 35.732 36 28C36 18 24 6 24 6Z" 
                                fill="white" opacity="0.15"/>
                          
                          {/* Блики чистоты */}
                          <circle cx="20" cy="22" r="2.5" fill="white" opacity="0.7"/>
                          <circle cx="28" cy="26" r="1.5" fill="white" opacity="0.6"/>
                          <ellipse cx="17" cy="30" rx="3" ry="1.5" fill="white" opacity="0.4"/>
                          
                          {/* Волны внутри капли */}
                          <path d="M16 32C18 31 20 31 22 32C24 33 26 33 28 32C30 31 32 31 32 32" 
                                stroke="white" strokeWidth="1.5" opacity="0.5" strokeLinecap="round"/>
                          <path d="M14 36C16 35 20 35 24 36C28 37 30 37 32 36" 
                                stroke="white" strokeWidth="1.5" opacity="0.4" strokeLinecap="round"/>
                          
                          {/* Маленькие капли вокруг */}
                          <path d="M10 14C10 14 8 16 8 17.5C8 18.88 9.12 20 10.5 20C11.88 20 13 18.88 13 17.5C13 16 10 14 10 14Z" 
                                fill="white" opacity="0.6"/>
                          <path d="M38 16C38 16 36 18 36 19.5C36 20.88 37.12 22 38.5 22C39.88 22 41 20.88 41 19.5C41 18 38 16 38 16Z" 
                                fill="white" opacity="0.6"/>
                          <path d="M14 38C14 38 13 39 13 40C13 40.83 13.67 41.5 14.5 41.5C15.33 41.5 16 40.83 16 40C16 39 14 38 14 38Z" 
                                fill="white" opacity="0.5"/>
                        </svg>
                    </div>
                    <h3 className={styles.benefit_title}>Природный источник</h3>
                    <p className={styles.benefit_desc}>Артезианская скважина №5036 глубиной 500 метров обеспечивает чистейшую природную воду</p>
                </div>
            </div>

            <div className={"card__wrapper " + styles.wrapper_around}>
                <div className={"card__content " + styles.card__content}>
                    <div className={styles.benefit_icon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {/* Сертификат с печатью */}
                          <rect x="10" y="8" width="28" height="32" rx="2" stroke="white" strokeWidth="2.5"/>
                          <path d="M16 16H32M16 22H32M16 28H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                          <circle cx="32" cy="32" r="6" fill="white" opacity="0.3"/>
                          <circle cx="32" cy="32" r="6" stroke="white" strokeWidth="2"/>
                          <path d="M29.5 32L31 33.5L34.5 30" stroke="#0060B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h3 className={styles.benefit_title}>Сертифицированное качество</h3>
                    <p className={styles.benefit_desc}>Соответствие Техническому регламенту Таможенного Союза и всем стандартам Республики Казахстан</p>
                </div>
            </div>
            
        </div>
        
    </section>
  )
}

export default VMainBenefits